import { useModels } from "../../Resources/ModelProvider.tsx";
import { Object3D } from "three";
import { PrototypeCardView } from "./PrototypeCardView.tsx";

export default function PrototypeCardCarousel() {
  const models: Object3D[] = [...useModels().models.values()];

  return (
    <div className={"absolute bottom-0 flex overflow-x-scroll w-full"}>
      <div className={"flex flex-nowrap"}>
        {models
          ? models.map((model, i) => {
              return <PrototypeCardView key={i} model={model} index={i} />;
            })
          : null}
      </div>
    </div>
  );
}
